<template>
  <div>
    <el-upload
      :action="url"
      :show-file-list="false"
      :on-success="handleAvatarSuccess"
      :on-error="handleError"
      :before-upload="beforeAvatarUpload"
      :headers="uploadHeader()"
      :multiple="false"
      :accept="accept"
      :data="data"
    >
      <slot name="uploadContent"></slot>
    </el-upload>
  </div>
</template>

<script>
import Util from "@lib/util.js";
import BaseApi from "@lib/baseApi.js";
export default {
  data() {
    return {
      data: {},
      loading: false,
    };
  },
  props: ["url", "size", "format", "uploadType", "curCount", "accept"],
  async mounted() {
    await this.uploadContractLimt().then((data) => {
      this.data.maxCount = data.datas.maxCount;
      this.data.maxSize = data.datas.maxSize;
    });
  },

  methods: {
    handleAvatarSuccess(res, file) {
      this.$emit("loadingEnd");
      if (res.code == 200) {
        this.$emit("uploadSuccess", res);
      } else {
        if (res.code == 102 || res.code == 103) {
          window.location.href = "/verification/login";
        } else {
          this.$message.error(res.message || "上传失败");
        }
      }
    },
    handleError() {
      this.$emit("loadingEnd");
      this.$message.error("上传失败");
    },
    uploadContractLimt() {
      return BaseApi.createRpcToken("/file/uploadContractLimt", "", "post");
    },
    beforeAvatarUpload(file) {
      this.data.fileName = file.name;
      console.log(file.name, 'file.name')
      let isLt30M = 30;
      if (this.accept) {
        let acceptList = this.accept.split(',');
        let fileExtension = "";
        if (file.name.lastIndexOf(".") > -1) {
          fileExtension = file.name.slice(file.name.lastIndexOf("."));
        }
        console.log(fileExtension, 'fileExtension')
        const isTypeOk = acceptList.some((type) => {
          // if (file.type.indexOf(type) > -1) return true;
          if (fileExtension && fileExtension.indexOf(type) > -1) return true;
          return false;
        });
        if (!isTypeOk) {
          this.$message.error(
            `文件格式不正确, 请上传${acceptList.join("/")}格式文件!`
          );
          return false;
        }
      }
      if (this.uploadType == "contract") {
        isLt30M = file.size / 1024 / 1024 < this.data.maxSize;
        if (this.curCount >= this.data.maxCount) {
          this.$message.error(`上传的文件不能超过${this.data.maxCount}个!`);
          return false;
        } else if (!isLt30M) {
          this.$message.error(`上传的文件不能超过${this.data.maxSize}M!`);
          return false;
        } else {
          this.$emit("loading");
          return true;
        }
      } else {
        isLt30M = file.size / 1024 / 1024 < 30;
        if (!isLt30M) {
          this.$message.error("上传的文件不能超过30M!");
        } else {
          this.$emit("loading");
        }
        return isLt30M;
      }
    },
    uploadHeader() {
      return {
        token: localStorage.token || "mVYUzIuJCAmoOjgiI0xaaW8mfqJGPq",
        "X-CSRF-Token": sessionStorage.token,
        "request-id": Util.getUID(),
      };
    },
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss">
</style>
